import { ADMIN_PAGE_PATH } from './paths';
import DashboardIcon from '@mui/icons-material/Dashboard';
export const SidebarData = [
  {
    name: 'Dashboard',
    path: ADMIN_PAGE_PATH,
    icon: <DashboardIcon />,
  },
];
